
import { supabase } from '@/integrations/supabase/client';
import { securityLogger } from './securityLogger';

export const validationUtils = {
  // Enhanced input validation
  sanitizeInput(input: string): string {
    if (!input || typeof input !== 'string') return '';
    
    // Remove potentially dangerous characters
    return input
      .replace(/[<>]/g, '') // Remove angle brackets
      .replace(/javascript:/gi, '') // Remove javascript: protocol
      .replace(/on\w+=/gi, '') // Remove event handlers
      .trim()
      .slice(0, 1000); // Limit length
  },

  // Rate limiting check (basic implementation)
  async checkRateLimit(action: string, maxAttempts: number = 10, windowMinutes: number = 5): Promise<boolean> {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return false;

      const windowStart = new Date(Date.now() - windowMinutes * 60 * 1000);
      
      const { data, error } = await supabase
        .from('audit_logs')
        .select('id')
        .eq('user_id', user.id)
        .eq('action', action)
        .gte('created_at', windowStart.toISOString());

      if (error) {
        console.error('Error checking rate limit:', error);
        return true; // Allow on error to avoid blocking legitimate users
      }

      const attemptCount = data?.length || 0;
      const isWithinLimit = attemptCount < maxAttempts;

      if (!isWithinLimit) {
        await securityLogger.logSecurityEvent('rate_limit_exceeded', {
          user_id: user.id,
          action,
          attempts: attemptCount,
          max_attempts: maxAttempts,
          window_minutes: windowMinutes
        });
      }

      return isWithinLimit;
    } catch (error) {
      console.error('Error in rate limit check:', error);
      return true; // Allow on error
    }
  }
};
